import { Box, Stack, StackProps } from "@mui/material";
import { EventStatus } from "graphql/generated/types";
import { mergeSx, Sx } from "utils/sx";

export type EventCardDetailsSectionProps = {
    children: React.ReactNode;
    status?: EventStatus
} & StackProps

const styles: Sx = (theme) => ({
    backgroundColor: "var(--background-color-details)",
    padding: theme.spacing(1.5, 2),
    alignItems: "center",
    "&:last-of-type": {
        borderRadius: theme.spacing(0, 0, 0.5, 0.5),
    },
});

const liveStyles: Sx = {
    backgroundColor: "var(--background-color-details-live)",
};

export const EventCardDetailsSection: React.FC<EventCardDetailsSectionProps> = ({ children, status, sx, ...props }) => {    
    return (
        <Stack
            position="relative"
            direction="row"
            spacing={.5}
            sx={mergeSx(styles, status === "on" && liveStyles, sx)}
            data-testid="event-card-details-section"
            {...props}
        >
            <CurvedAccents status={status} />

            {children}
        </Stack>
    );
};

const curvedAccentStylesOuter: Sx = theme => ({
    position: "absolute",
    bottom: "100%",
    left: 0,
    right: 0,
    height: theme.shape.borderRadius,
    overflow: "hidden",
});

const curvedAccentStylesInner: Sx = theme => ({
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: theme.spacing(1),
    borderRadius: `0 0 ${theme.shape.borderRadius}px ${theme.shape.borderRadius}px`,
    boxShadow: `0 0 0 ${theme.spacing(1)} var(--background-color-details)`,
});

const curvedAccentStylesInnerLive: Sx = theme => ({
    boxShadow: `0 0 0 ${theme.spacing(1)} var(--background-color-details-live)`,
});

const CurvedAccents: React.FC<{ status: EventStatus | undefined }> = ({ status }) => {
    return (
        <Box sx={curvedAccentStylesOuter}>
            <Box sx={mergeSx(curvedAccentStylesInner, status === "on" && curvedAccentStylesInnerLive)} />
        </Box>
    );
};
